/**
 * Protected route component that requires authentication
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../shared/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Skip setup wizard check (for the setup wizard page itself) */
  skipSetupCheck?: boolean;
}

export function ProtectedRoute({ children, skipSetupCheck = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login with return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user needs to complete setup wizard (no tenant assigned)
  if (!skipSetupCheck && user && !user.tenant_id) {
    return <Navigate to="/setup" replace />;
  }

  return <>{children}</>;
}
